/**
 * @fileoverview Contiene los servicios de consumo a la API para Flotillas
 *
 * @version 1.0
 *
 * @author José Antonio Rodríguez Barceló <rbsistemas@hotmail.com>
 *
 * @copyright Shuttle Express México
 *
 * Historial
 * ---------
 * La primera versión fue escrita por José Antonio Rodríguez Barceló
 */

import api from '@/services/api'
const END_POINT = '/flotillas'

export default {
  /**
   * @name getFleets
   * @description Obtiene un listado de documentos segun parametros
   *
   * @param {*} params campo1 -> Parametros para poblar el select
   * @returns {array} devuelve un arreglo de json con los documentos
   */
  getFleets(params) {
    if (params != null) {
      return api.get(END_POINT + params)
    }
    return api.get(END_POINT)
  },

  /**
   * @name postFleet
   * @description Se crea el vehiculo de la flotilla
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para crear el Genero
   */
  postFleet(body) {
    return api.post(END_POINT, body)
  },

  /**
   * @name patchFleet
   * @description Se actualiza el vehiculo de la flotilla
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para actualizar el Genero
   * @param {*} id this.editedItem._id -> id del Genero que se va a actualizar
   */
  patchFleet(body, id) {
    return api.patch(END_POINT + '/' + id, body)
  },

  /**
   * @name deleteFleet
   * @description Elimina un documento por su id
   *
   * @param {*} id _id -> id del documento que se va a eliminar
   * @returns {json} json con el resultado de eliminar el documento
   */
  deleteFleet(id) {
    return api.delete(END_POINT + '/' + id)
  },
}
